(() => {
  function parseValue(value, fallback = 0) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function syncPriceRange(wrap) {
    if (!wrap || wrap.dataset.bcInit === 'true') return;

    const textMin = wrap.querySelector('[data-bc-text-min]');
    const textMax = wrap.querySelector('[data-bc-text-max]');
    const rangeMin = wrap.querySelector('[data-bc-range-min]');
    const rangeMax = wrap.querySelector('[data-bc-range-max]');

    if (!textMin || !textMax || !rangeMin || !rangeMax) return;

    wrap.dataset.bcInit = 'true';

    const maxVal = parseValue(wrap.dataset.bcRangeMax || rangeMin.max, 1);

    const updateProgress = () => {
      let minValue = parseValue(rangeMin.value, 0);
      let maxValue = parseValue(rangeMax.value, maxVal);

      if (maxValue < minValue) {
        maxValue = minValue;
        rangeMax.value = String(maxValue);
      }

      const start = `${((minValue / maxVal) * 100).toFixed(2)}%`;
      const end = `${((maxValue / maxVal) * 100).toFixed(2)}%`;
      wrap.style.setProperty('--bc-range-start', start);
      wrap.style.setProperty('--bc-range-end', end);
    };

    const updateZIndex = () => {
      const minValue = parseValue(rangeMin.value, 0);
      const maxValue = parseValue(rangeMax.value, maxVal);

      if (maxValue <= minValue) {
        rangeMin.style.zIndex = '3';
        rangeMax.style.zIndex = '2';
      } else {
        rangeMin.style.zIndex = '2';
        rangeMax.style.zIndex = '3';
      }
    };

    const commitMin = () => {
      textMin.value = rangeMin.value;
      textMin.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const commitMax = () => {
      textMax.value = rangeMax.value;
      textMax.dispatchEvent(new Event('input', { bubbles: true }));
    };

    rangeMin.addEventListener('input', () => {
      let minValue = parseValue(rangeMin.value, 0);
      const maxValue = parseValue(rangeMax.value, maxVal);

      if (minValue > maxValue) {
        minValue = maxValue;
        rangeMin.value = String(minValue);
      }

      textMin.value = String(minValue);
      updateProgress();
      updateZIndex();
    });

    rangeMax.addEventListener('input', () => {
      const minValue = parseValue(rangeMin.value, 0);
      let maxValue = parseValue(rangeMax.value, maxVal);

      if (maxValue < minValue) {
        maxValue = minValue;
        rangeMax.value = String(maxValue);
      }

      textMax.value = String(maxValue);
      updateProgress();
      updateZIndex();
    });

    rangeMin.addEventListener('change', () => {
      updateProgress();
      commitMin();
    });

    rangeMax.addEventListener('change', () => {
      updateProgress();
      commitMax();
    });

    textMin.addEventListener('input', () => {
      const minValue = parseValue(textMin.value, 0);
      if (minValue < 0 || minValue > maxVal) return;
      rangeMin.value = String(minValue);
      updateProgress();
      updateZIndex();
    });

    textMax.addEventListener('input', () => {
      const maxValue = parseValue(textMax.value, maxVal);
      if (maxValue < 0 || maxValue > maxVal) return;
      rangeMax.value = String(maxValue);
      updateProgress();
      updateZIndex();
    });

    updateProgress();
    updateZIndex();
  }

  function initPriceRanges(root = document) {
    root.querySelectorAll('[data-bc-price-range]').forEach(syncPriceRange);
  }

  window.BCPriceRangeInit = initPriceRanges;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPriceRanges());
  } else {
    initPriceRanges();
  }
})();
